import { Injectable } from '@angular/core';
import { BaseApiService } from '../../base-service/base-api.service';

@Injectable()
export class AutoCompleteService extends BaseApiService {
    public servicePath: string;
    public serviceIdPath: string;

    getDataById(id: number) {
        return this.get(this.serviceIdPath + '/' + id);
    }

    getDataByText(filter: string) {
        return this.get(this.servicePath + '/' + filter);
    }

    getDataByParent(parentId: number, filter: any) {
        return this.get(this.servicePath.replace('{parentId}', parentId.toString()) +
            '/' +
            filter);
    }
}
